import Highcharts from "highcharts";
import klh from "./klhPalette";
import { chartCategorical } from "./chartPalette";

/**
 * Tema Highcharts global — diterapkan sekali dari src/index.js dan berlaku untuk
 * seluruh grafik Highcharts di aplikasi (11 berkas) tanpa perlu diubah satu per satu.
 *
 * Legenda sengaja dipaksa menyala: peringatan kontras pada dua oranye paling
 * terang di palet mewajibkan identitas seri dibawa oleh sesuatu selain warna.
 */
Highcharts.setOptions({
  colors: chartCategorical,

  chart: {
    backgroundColor: "transparent",
    style: {
      fontFamily: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    },
  },

  title: {
    style: { color: klh.ink[900], fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: "700" },
  },

  subtitle: {
    style: { color: klh.ink[500] },
  },

  xAxis: {
    lineColor: klh.neutral.line,
    tickColor: klh.neutral.line,
    gridLineColor: klh.neutral.line,
    labels: { style: { color: klh.ink[500] } },
    title: { style: { color: klh.ink[500] } },
  },

  yAxis: {
    gridLineColor: klh.neutral.line,
    lineColor: klh.neutral.line,
    tickColor: klh.neutral.line,
    labels: { style: { color: klh.ink[500] } },
    title: { style: { color: klh.ink[500] } },
  },

  legend: {
    enabled: true,
    itemStyle: { color: klh.ink[700], fontWeight: "500" },
    itemHoverStyle: { color: klh.ink[900] },
  },

  tooltip: {
    backgroundColor: klh.neutral.surface,
    borderColor: klh.neutral.line,
    borderRadius: 12,
    style: { color: klh.ink[900] },
  },

  credits: { enabled: false },
});

export default Highcharts;
